// extracted by mini-css-extract-plugin
export var button = "_sy-1";
export var container = "_sy-0";